import WelcomeBlock from './WelcomeBlock';
import { WelcomeBlockProps, WelcomeBlockValueProps } from './types';

export type { WelcomeBlockProps, WelcomeBlockValueProps };
export default WelcomeBlock;
